import { render, staticRenderFns } from "./CadastroProdutor.vue?vue&type=template&id=69e23788&"
import script from "./CadastroProdutor.vue?vue&type=script&lang=js&"
export * from "./CadastroProdutor.vue?vue&type=script&lang=js&"
import style0 from "./CadastroProdutor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBottomNavigation } from 'vuetify/lib/components/VBottomNavigation';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBottomNavigation,VBtn,VTextField})
